import { IPart } from "./Part";
import { ISalesQuote } from "./SalesQuote";
import { BaseEntity, DefaultResponseWithData } from "./system";


export interface GetUserBasketResponse extends DefaultResponseWithData<IBasket> { }


export interface IBasket extends BaseEntity {
  userId: string;
  status: BasketStatus;
  completedOn: string;
  shippingPolicyId?: string;
  /** Set while a sales quote is loaded into this basket; checkout converts it. */
  salesQuoteId?: string | null;
  salesQuote?: ISalesQuote | null;

  items: IBasketItem[];
}

export enum BasketStatus {
  Pending,
  Completed,
}

export enum DiscountType {
  Flat = "flat",
  Percentage = "percentage",
}

export interface IBasketItem extends BaseEntity {
  taxRate: number;
  basketPrice?: number;

  basketId: string;
  basket: IBasket;

  partId: string;
  part: IPart;
}